import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './customObjectValuesInstances.intl.json';

export const useCustomObjectValuesIntl = () => {
  return useIntlModule(messages);
};
